(function(){
  'use strict';

  // Autoplay vidéos quand elles entrent dans le viewport (muted)
  if (!('IntersectionObserver' in window)) return;

  function initUGC(){
    var cards = document.querySelectorAll('[data-nuvy-ugc-card]');
    if (!cards.length) return;

    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var video = entry.target.querySelector('[data-nuvy-ugc-video]');
        if (!video) return;

        if (entry.isIntersecting && entry.intersectionRatio > 0.5){
          var playPromise = video.play();
          if (playPromise !== undefined){
            playPromise.catch(function(){ /* autoplay bloqué silencieusement */ });
          }
        } else {
          video.pause();
        }
      });
    }, { threshold: [0, 0.5, 1] });

    cards.forEach(function(card){
      observer.observe(card);
    });

    // Bouton son : toggle mute
    document.querySelectorAll('[data-nuvy-ugc-sound]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.stopPropagation();
        var card = btn.closest('[data-nuvy-ugc-card]');
        if (!card) return;
        var video = card.querySelector('[data-nuvy-ugc-video]');
        if (!video) return;

        // Mute tous les autres
        document.querySelectorAll('[data-nuvy-ugc-video]').forEach(function(v){
          if (v !== video){
            v.muted = true;
            var otherBtn = v.closest('[data-nuvy-ugc-card]').querySelector('[data-nuvy-ugc-sound]');
            if (otherBtn){
              otherBtn.querySelector('.nuvy-ugc__sound-icon--mute').style.display = '';
              otherBtn.querySelector('.nuvy-ugc__sound-icon--on').style.display = 'none';
              otherBtn.setAttribute('aria-label', 'Activer le son');
            }
          }
        });

        video.muted = !video.muted;
        var muteIcon = btn.querySelector('.nuvy-ugc__sound-icon--mute');
        var onIcon = btn.querySelector('.nuvy-ugc__sound-icon--on');
        if (video.muted){
          muteIcon.style.display = '';
          onIcon.style.display = 'none';
          btn.setAttribute('aria-label', 'Activer le son');
        } else {
          muteIcon.style.display = 'none';
          onIcon.style.display = '';
          btn.setAttribute('aria-label', 'Couper le son');
        }
      });
    });

    // Click sur la vidéo : play/pause
    document.querySelectorAll('[data-nuvy-ugc-video]').forEach(function(video){
      video.addEventListener('click', function(){
        if (video.paused){
          video.play();
        } else {
          video.pause();
        }
      });
    });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initUGC);
  } else {
    initUGC();
  }
})();
